import { useContext } from 'react'
import { blackCardContext } from 'root/src/client/web/base/Card/BlackCard/contexts/blackCardContext'

export const useBlackCardContext = () => {
	if (!blackCardContext) {
		throw new Error('useBlackCardContext must be used within a BlackCardProvider')
	}
	return useContext(blackCardContext)
}
